import styled from 'styled-components';

const TableCell = styled.td`
  padding: 12px 20px;
  letter-spacing: 0.25px;
  text-align: left;
  white-space: nowrap;
`;

export { TableCell };
